import { render, staticRenderFns } from "./OptionSelect.vue?vue&type=template&id=0e474107&scoped=true"
import script from "./OptionSelect.vue?vue&type=script&lang=ts"
export * from "./OptionSelect.vue?vue&type=script&lang=ts"
import style0 from "./OptionSelect.vue?vue&type=style&index=0&id=0e474107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e474107",
  null
  
)

export default component.exports